import {
    HTTP
} from '../http-common'

import main from './main'

export default {
    state: {
        adminsList: [],
        usersList: [],
        adminsTotal: 0,
        membersAutocomplete: [],
        accessGroups: [],
        adminCard: {},
        userAccessGroups: [],
        references: [],
        userReferences: [],
        megogoList: [],
        megogoCodeStat: [],
        megogoAvailList: [],
        megogoSoldList: [],
        youtvList: [],
        youtvCodeStat: [],
        youtvAvailList: [],
        youtvSoldList: [],
        sellHistoryList: [],
        sellYoutvHistoryList: [],
        sellEpicentrkHistoryList: [],
        megogoSoldData: [],
        youtvSoldData: [],
        epicentrkMegogoCodesList: [],
        epicentrkMegogoSoldCodesList: [],
        epicentrkMegogoSoldData: [],
        epicentrkMegogoSoldList: [],
        egiftsList: [],
        egiftsSellHistoryList: [],
        egiftsAvailList: [],
        projectsList: [],
        egiftsCodeStat: [],
        egiftsSoldList: [],
        egiftsSoldData: [],
        egiftsSoldDocumentsList: []

    },
    mutations: {
        setAdminsList(state, payload) {
            state.adminsList = payload
        },
        setUsersList(state, payload) {
            state.usersList = payload
        },
        setAdminsTotal(state, payload) {
            state.adminsTotal = payload
        },
        setMembersAutocomplete(state, payload) {
            state.membersAutocomplete = payload
        },
        setAccessGroups(state, payload) {
            state.accessGroups = payload
        },
        setUserAccessGroups(state, payload) {
            state.userAccessGroups = payload
        },
        setAdminCard(state, payload) {
            state.adminCard = payload
        },
        setReferences(state, payload) {
            state.references = payload
        },
        setUserReferences(state, payload) {
            state.userReferences = payload
        },
        setMegogoList(state, payload) {
            state.megogoList = payload
        },
        setMegogoServiceCodeStat(state, payload) {
            state.megogoCodeStat = payload
        },
        setMegogoAvailList(state, payload) {
            state.megogoAvailList = payload
        },
        setMegogoSoldList(state, payload) {
            state.megogoSoldList = payload
        },
        setYoutvList(state, payload) {
            state.youtvList = payload
        },
        setYoutvServiceCodeStat(state, payload) {
            state.youtvCodeStat = payload
        },
        setYoutvAvailList(state, payload) {
            state.youtvAvailList = payload
        },
        setYoutvSoldList(state, payload) {
            state.youtvSoldList = payload
        },
        setSellHistoryList(state, payload) {
            state.sellHistoryList = payload
        },
        setYoutvSellHistoryList(state, payload) {
            state.sellYoutvHistoryList = payload
        },
        setSellEpicentrkHistoryList(state, payload) {
            state.sellEpicentrkHistoryList = payload
        },
        setMegogoSoldData(state, payload) {
            state.megogoSoldData = payload
        },
        setYoutvSoldData(state, payload) {
            state.youtvSoldData = payload
        },
        setEpicentrkMegogoCodesList(state, payload) {
            state.epicentrkMegogoCodesList = payload
        },
        setEpicentrkMegogoSoldCodesList(state, payload) {
            state.epicentrkMegogoSoldCodesList = payload
        },
        setEpicentrkMegogoSoldData(state, payload) {
            state.epicentrkMegogoSoldData = payload
        },
        setEpicentrkMegogoSoldList(state, payload) {
            state.epicentrkMegogoSoldList = payload
        },
        setEgiftsList(state, payload) {
            state.egiftsList = payload
        },
        setEgiftsSellHistoryList(state, payload) {
            state.egiftsSellHistoryList = payload
        },
        setEgiftsAvailList(state, payload) {
            state.egiftsAvailList = payload
        },
        setProjectsList(state, payload) {
            state.projectsList = payload
        },
        setEgiftsCodeStat(state, payload) {
            state.egiftsCodeStat = payload
        },
        setEgiftsSoldList(state, payload) {
            state.egiftsSoldList = payload
        },
        setEgiftsSoldData(state, payload) {
            state.egiftsSoldData = payload
        },
        setEgiftsSoldDocumentsList(state, payload) {
            state.egiftsSoldDocumentsList = payload
        }
    },
    actions: {
        getAdminsList({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/admins-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setAdminsList', response.data.content)
                            commit('setAdminsTotal', response.data.content.length)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setAdminsList', [])
                            commit('setAdminsTotal', 0)
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getUsersList({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/users-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setUsersList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setUsersList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogoList({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/megogo-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMegogoList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setMegogoList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvList({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/youtv-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setYoutvList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMembersAutocomplete({
            commit,
        }, query) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/members-autocomplete?query=' + query,)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMembersAutocomplete', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setMembersAutocomplete', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getAccessGroups({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/access-groups')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setAccessGroups', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setAccessGroups', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getUserAccessGroups({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/user-access-groups/' + id)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setUserAccessGroups', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setUserAccessGroups', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogoServiceCodeStat({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/megogo-service-code-stat/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMegogoServiceCodeStat', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setMegogoServiceCodeStat', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvServiceCodeStat({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/youtv-service-code-stat/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvServiceCodeStat', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setYoutvServiceCodeStat', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogoAvailList({
            commit,
        }, list) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                const query = { list }
                HTTP.post('/adminpanel/megogo-avail-list/', query)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMegogoAvailList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setMegogoAvailList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvAvailList({
            commit,
        }, list) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                const query = { list }
                HTTP.post('/adminpanel/youtv-avail-list/', query)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvAvailList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setYoutvAvailList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogoStat({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/megogo-stat/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvStat({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/youtv-stat/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogoStatExport({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/megogo-stat-export/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvStatExport({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/youtv-stat-export/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        createXlsx(c, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/xlsx/file', data)
                    .then(() => {
                        main.state.loading = false
                        resolve()
                    }
                    )
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getReferences({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/references/' + id)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setReferences', response.data.content.reference)
                            commit('setUserReferences', response.data.content.userReference)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setReferences', [])
                            commit('setUserReferences', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getUserShops({
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/user-shops/' + id)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getUserContractors({
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/user-contractors/' + id)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogoServiceData({
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/megogo-data/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvServiceData({
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/youtv-data/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        addNewAdmin({
        }, f) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/add-admin', f)
                    .then(response => {
                        resolve()
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        editAdmin({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/edit-admin/' + id)
                    .then(response => {
                        commit('setAdminCard', response.data.content)
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        commit('setAdminCard', {})
                        console.error(e)
                        reject(e)
                    })
            })
        },
        editUser({
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/edit-user/' + id)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateAdmin({
        }, f) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-admin/', f)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateUser({
        }, f) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-user/', f)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateMegogoItem({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-megogo/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateYoutvItem({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-youtv/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateYoutvItem({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-youtv/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateMegogoServiceData({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-megogo-service-data/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateYoutvServiceData({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-youtv-service-data/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        checkPhone({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/check-phone/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve()
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMemberData({
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/get-member-data/' + id)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        buyPackageCodes({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/buy-package-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        buyYoutvPackageCodes({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/buy-youtv-package-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getSellHistory({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/sell-history-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setSellHistoryList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setSellHistoryList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvSellHistory({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/youtv-sell-history-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvSellHistoryList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setYoutvSellHistoryList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogSoldList({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/megogo-sold-list/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMegogoSoldList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setMegogoSoldList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvSoldList({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/youtv-sold-list/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvSoldList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setYoutvSoldList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getMegogSoldData({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/megogo-history-data/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMegogoSoldData', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setMegogoSoldData', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getYoutvSoldData({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/youtv-history-data/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvSoldData', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setYoutvSoldData', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        sendMegogoToTyphoon({
            commit,
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/send-megogo-to-typhoon/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        sendYoutvToTyphoon({
            commit,
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/send-youtv-to-typhoon/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkMegogoCodes({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/get-epicentrk-megogo-codes/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEpicentrkMegogoCodesList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkMegogoSoldCodes({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/get-epicentrk-megogo-codes/', { statusCode: 2, reservedToken: 1 })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEpicentrkMegogoSoldCodesList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        createTyphoonDocuments({
            commit,
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/create-megogo-typhoon-documents/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        createYoutvTyphoonDocuments({
            commit,
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/create-youtv-typhoon-documents/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkSellHistory({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/sell-epicentrk-history-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setSellEpicentrkHistoryList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setSellEpicentrkHistoryList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkMegogSoldData({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/epicentrk-megogo-history-data/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEpicentrkMegogoSoldData', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEpicentrkMegogoSoldData', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkMegogSoldList({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/epicentrk-megogo-sold-list/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEpicentrkMegogoSoldList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEpicentrkMegogoSoldList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkMegogoStatExport({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/epicentrk-megogo-stat-export/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        importEpicentrkMegogoCodes({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/epicentrk-megogo-import-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEpicentrkMegogoCodesExport({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/get-epicentrk-megogo-codes-export/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        importMegogoCodes({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/megogo-import-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        importYoutvCodes({
        }, data) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/youtv-import-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        // ------------------------------------------- EGIFTS -------------------------------------------
        getEgiftsList({
            commit,
        }) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/egifts-list/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEgiftsList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsSoldDocumentsList({
            commit,
        }, reservedToken) {
            return new Promise(async (resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-sold-documents-list/', { reservedToken })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsSoldDocumentsList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEgiftsSoldDocumentsList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateEgiftsItem({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-egifts-item/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsServiceData({
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-service-data/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        updateEgiftsServiceData({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/update-egifts-service-data/', data)
                    .then(response => {
                        resolve(response.data.content)
                        main.state.loading = false
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsServiceCodeStat({ commit
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-service-code-stat/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsCodeStat', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsStatExport({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-stat-export/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsStat({ }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-stat/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsAvailList({
            commit
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-avail-list/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsAvailList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEgiftsAvailList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsUsedList({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-used-list/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        buyEgiftsPackageCodes({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/buy-egifts-package-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsSellHistory({
            commit,
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/egifts-sell-history-list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsSellHistoryList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEgiftsSellHistoryList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        importEgiftsCodes({
            commit
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/import-egifts-codes/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        }
                        else {
                            resolve([])
                            main.state.loading = false
                        }
                        resolve([])
                        main.state.loading = false
                    }
                    )
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsProjectsList({
            commit
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.get('/adminpanel/egifts-projects-list/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setProjectsList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setProjectsList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsUnorderedGoods({
        }, data) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-unordered-goods/', data)
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        }
                        else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsSoldList({
            commit,
        }, reserved_token) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-sold-list/', { reserved_token })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsSoldList', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEgiftsSoldList', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        getEgiftsSoldData({
            commit,
        }, id) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/adminpanel/egifts-history-data/', { id })
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setEgiftsSoldData', response.data.content)
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            commit('setEgiftsSoldData', [])
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        }
    }
}